import { useState } from 'react'

import { ScanStats } from '../components/ScanStats'
import { t } from '../i18n/lingua'

/**
 * Statistiche delle scansioni — la pagina dedicata.
 *
 * La stessa fotografia del widget in dashboard, ma con la finestra scegliibile
 * e gli elenchi per esteso: cosa è comparso e cosa non si trova più, nel tempo.
 */
export default function ScanStatsPagina() {
  const [giorni, setGiorni] = useState(30)
  return (
    <>
      <header className="page__header">
        <div>
          <h1 className="page__title">{t('Statistiche scansioni')}</h1>
          <p className="page__subtitle">
            {t('Cosa compare e cosa non si trova più, nel tempo')}
          </p>
        </div>
        <div className="toolbar">
          <label className="field__inline">
            {t('Periodo')}
            <select value={giorni} onChange={(e) => setGiorni(Number(e.target.value))}>
              <option value={7}>{t('7 giorni')}</option>
              <option value={30}>{t('30 giorni')}</option>
              <option value={90}>{t('90 giorni')}</option>
            </select>
          </label>
        </div>
      </header>
      <ScanStats days={giorni} />
    </>
  )
}
